import React from "react";

import Chrome from "IndividualApplication/Chrome";
import { Link } from "react-router-dom";

import { LinkButton } from "Cobalt/Button";
import { Surface, SurfaceHeader, SurfaceSection } from "Cobalt/Surface";

export const IndividualDonePage = () => (
  <Chrome title="Application Complete">
    <Surface className="mt-5">
      <SurfaceHeader className="font-bold">Pending Digital Signature</SurfaceHeader>
      <SurfaceSection>
        <p className="text-body1">
          In order to complete your application, you will need to complete a digital signature sent by the carrier, Humana. You will receive a text message in
          the next 1-3 days prompting you to follow a link and complete your digital signature.
        </p>
      </SurfaceSection>
      <SurfaceSection>
        <LinkButton component={Link} href="/employee-dashboard">
          Return to Dashboard
        </LinkButton>
      </SurfaceSection>
    </Surface>
  </Chrome>
);
